{
  "SLA": {
    "HEADER": "Dohody o úrovni služeb",
    "ADD_ACTION": "Přidat SLA",
    "ADD_ACTION_LONG": "Vytvořit novou SLA politiku",
    "DESCRIPTION": "Dohody o úrovni služeb (SLA) jsou smlouvy, které definují jasná očekávání mezi vaším týmem a zákazníky. Stanovují standardy pro čas odpovědi a řešení, vytvářejí rámec pro odpovědnost a zajišťují konzistentní, vysoce kvalitní zkušenost.",
    "LEARN_MORE": "Více o SLA",
    "LOADING": "Načítám SLA",
    "PAYWALL": {
      "TITLE": "Pro vytvoření SLA proveďte upgrade",
      "AVAILABLE_ON": "Funkce SLA je dostupná pouze v plánech Business a Enterprise.",
      "UPGRADE_PROMPT": "Upgradujte svůj plán, abyste získali přístup k pokročilým funkcím jako je správa týmů, automatizace, vlastní atributy a další.",
      "UPGRADE_NOW": "Upgradovat nyní",
      "CANCEL_ANYTIME": "Svůj plán můžete kdykoli změnit nebo zrušit"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Funkce SLA je dostupná pouze v placených plánech.",
      "UPGRADE_PROMPT": "Upgradujte na placený plán pro přístup k pokročilým funkcím jako jsou auditní logy, kapacita agentů a další.",
      "ASK_ADMIN": "Pro upgrade kontaktujte prosím svého administrátora."
    },
    "LIST": {
      "404": "V tomto účtu nejsou k dispozici žádné SLA.",
      "EMPTY": {
        "TITLE_1": "Podnikové P0",
        "DESC_1": "Problémy vznesené podnikovými zákazníky, které vyžadují okamžitou pozornost.",
        "TITLE_2": "Podnikové P1",
        "DESC_2": "Problémy vznesené podnikovými zákazníky, které je třeba rychle uznat."
      },
      "BUSINESS_HOURS_ON": "V pracovní době",
      "BUSINESS_HOURS_OFF": "Mimo pracovní dobu",
      "RESPONSE_TYPES": {
        "FRT": "Limit času první odpovědi",
        "NRT": "Limit času další odpovědi",
        "RT": "Limit času vyřešení",
        "SHORT_HAND": {
          "FRT": "FRT",
          "NRT": "NRT",
          "RT": "RT"
        }
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Název SLA",
        "PLACEHOLDER": "Název SLA",
        "REQUIRED_ERROR": "Název SLA je povinný",
        "MINIMUM_LENGTH_ERROR": "Je vyžadována minimální délka 2 znaky",
        "VALID_ERROR": "Povolena jsou pouze písmena, čísla, pomlčky a podtržítka"
      },
      "DESCRIPTION": {
        "LABEL": "Popis",
        "PLACEHOLDER": "SLA pro prémiové zákazníky"
      },
      "FIRST_RESPONSE_TIME": {
        "LABEL": "Čas první odpovědi",
        "PLACEHOLDER": "5"
      },
      "NEXT_RESPONSE_TIME": {
        "LABEL": "Čas další odpovědi",
        "PLACEHOLDER": "5"
      },
      "RESOLUTION_TIME": {
        "LABEL": "Čas k vyřešení",
        "PLACEHOLDER": "60"
      },
      "BUSINESS_HOURS": {
        "LABEL": "Pracovní doba",
        "PLACEHOLDER": "Pouze během pracovní doby"
      },
      "THRESHOLD_TIME": {
        "INVALID_FORMAT_ERROR": "Limit by měl být číslo větší než nula"
      },
      "EDIT": "Upravit",
      "CREATE": "Vytvořit",
      "DELETE": "Vymazat",
      "CANCEL": "Zrušit"
    },
    "ADD": {
      "TITLE": "Přidat SLA",
      "DESC": "Přátelské sliby pro skvělý servis!",
      "API": {
        "SUCCESS_MESSAGE": "SLA úspěšně přidáno",
        "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
      }
    },
    "DELETE": {
      "TITLE": "Smazat SLA",
      "API": {
        "SUCCESS_MESSAGE": "SLA úspěšně smazáno",
        "ERROR_MESSAGE": "Došlo k chybě, zkuste to prosím znovu"
      },
      "CONFIRM": {
        "TITLE": "Potvrdit odstranění",
        "MESSAGE": "Opravdu chcete odstranit ",
        "YES": "Ano, odstranit ",
        "NO": "Ne, zachovat "
      }
    },
    "EVENTS": {
      "TITLE": "Porušení SLA",
      "FRT": "Čas první odpovědi",
      "NRT": "Čas další odpovědi",
      "RT": "Čas vyřešení",
      "SHOW_MORE": "o {count} více",
      "HIDE": "Skrýt {count} řádků"
    }
  }
}